module.exports = __webpack_public_path__ + "static/img/energy.f01ecde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy.png
// module id = qeuM
// module chunks = 4